import { render, staticRenderFns } from "./NumberType.vue?vue&type=template&id=230eaed5&scoped=true&"
import script from "./NumberType.vue?vue&type=script&lang=js&"
export * from "./NumberType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230eaed5",
  null
  
)

export default component.exports